import React from 'react';
import LandingUI from '../core-ui/landing/landing-ui';

const Landing = () => <LandingUI />;

export default Landing;
